export const PASSWORD_MODE = {
	Change: "change",
	Changed: "changed",
	Saved: "saved",
	Locked: "locked",
} as const;

// ?pw values the Masuk page reads.
export type LoginPasswordMode = Exclude<
	(typeof PASSWORD_MODE)[keyof typeof PASSWORD_MODE],
	typeof PASSWORD_MODE.Changed
>;

const LOGIN_PASSWORD_MODES: readonly string[] = [
	PASSWORD_MODE.Change,
	PASSWORD_MODE.Saved,
	PASSWORD_MODE.Locked,
];

export const toLoginPasswordMode = (
	value: unknown,
): LoginPasswordMode | undefined =>
	typeof value === "string" && LOGIN_PASSWORD_MODES.includes(value)
		? (value as LoginPasswordMode)
		: undefined;
